import { ENDPOINTS } from '../utils/endpoints';
import { getAPIwithToken, postAPIwithToken, patchAPIwithToken } from '../utils/fetchApi';

export interface ApiSaleDocument {
  id: number;
  documentCode?: string;
  document_code?: string;
  description: string;
  status: number | string | boolean;
  is_active?: number;
  createdBy?: string;
  created_by?: string;
  createdOn?: string;
  createdAt?: string;
  created_at?: string;
  updatedAt?: string;
  updated_at?: string;
}

export interface GetSaleDocumentsResponse {
  success?: boolean;
  status?: string | number;
  message?: string;
  data?: ApiSaleDocument[];
}

export interface CreateSaleDocumentPayload {
  documentCode: string;
  description: string;
  status?: number;
}

export interface UpdateSaleDocumentPayload {
  id: number;
  documentCode?: string;
  description?: string;
  status?: number;
}

export async function getSaleDocumentsList(): Promise<GetSaleDocumentsResponse> {
  return getAPIwithToken<GetSaleDocumentsResponse>(ENDPOINTS.SALE_DOCUMENTS);
}

export async function createSaleDocument(
  payload: CreateSaleDocumentPayload
): Promise<any> {
  return postAPIwithToken(ENDPOINTS.SALE_DOCUMENTS, payload);
}

export async function updateSaleDocument(
  payload: UpdateSaleDocumentPayload
): Promise<any> {
  return patchAPIwithToken(ENDPOINTS.SALE_DOCUMENTS, payload);
}
